import { render, staticRenderFns } from "./edit-userexpressinfo.vue?vue&type=template&id=87ecad4a&scoped=true"
import script from "./edit-userexpressinfo.vue?vue&type=script&lang=ts"
export * from "./edit-userexpressinfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ecad4a",
  null
  
)

export default component.exports